module.exports = __webpack_public_path__ + "static/grid_responsive-e0f942a488fdb3edf08358a86bbe8200.mp4";